module.exports = __webpack_public_path__ + "static/media/jd100Origin.08cfc904.png";